import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { ClickToCopyComponent } from '../modules/shared/dialogs/click-to-copy/click-to-copy.component';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  public isSafari:boolean = false;
  public sortColumn:any = {column:'',direction:''}
  constructor(public notifier: NotifierService, private Dialoge:NgbModal) { }

  copyOnClick(str:string,type?:any){
    // console.log(str,'Utility');
      if(navigator.userAgent.indexOf("Safari") > -1 && !(navigator.userAgent.indexOf("Chrome") > -1)){
        this.isSafari = true;
      }
      if(!this.isSafari) {
        if(type && type != ''){
          this.notifier.notify('success',`${type} Copied to clipboard!`);
        }
        else
        {
          this.notifier.notify('success','Copied to clipboard!');
        }
        let textarea = document.createElement('textarea');
        textarea.setAttribute('type', 'hidden');
        textarea.textContent = str;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
      } else {
        const dialogRef = this.Dialoge.open(ClickToCopyComponent,{centered: true}); 
        dialogRef.componentInstance.data = {"text":str}
      }
  }
  closeDialoge()
  {
    this.Dialoge.dismissAll();
  }

  getSubStr(str:string, length:number, options?:any){
    if (!str) {
      return '';
    }else if(options && options.endLength){
      if (str.length > (length + options.endLength)) {
        return str.substring(0,length) + '...' + str.substring(str.length - options.endLength);
        }else{
          return str;
        }
    }else if (str.length > length) {
      if (str.substring(0,10) == '----------') {
        return str;
      }else{
        if (options && options.isDots) {
          return str.substring(0,length) + '...';
        }else{
          return str.substring(0,length)
        }
      }
    }else{
      return str;
    }
    
  }

  replaceUnderscore(str:string){
    return str.replace(/_/g, " ");
  }

  resetSortColumn(){
    this.sortColumn = {column:'',direction:''}
  }

}
